import React from 'react'

const Footer = () => {
  return (
    <>
        <footer className=" footer position-sticky ">
          <a href="https://www.workglow.in/" className='footerLink'>
        <p className="bglogo"></p>
      <p className=" text-center copyright">Copyright <span className="copyicon">&#169;</span> W<span className="wgcolor">o</span>rkgl<span className="wgcolor">o</span>w Solutions | All Rights Reserved</p>
      </a>
    </footer>
    </>
  )
}

export default Footer